import { Button, Drawer, Form, Input, Radio, Space, Spin, message } from "antd"
import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { fetchClassroom, generateSinglePupil, setGenerateSinglePupil } from "../features/prof/profsSlice";

export default function AddPupil({ open, setIsAddPupilOpen, classId }) {
    const [cookies] = useCookies();
    const dispatch = useDispatch();

    const formRef = useRef(null);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        classId,
    });
    const [pupilExists, setPupilExists] = useState(true);
    const [radioOptions, setRadioOptions] = useState(1);


    const generateSinglePupilSuccess = useSelector((state) => state.profs.generateSinglePupilSuccess);
    const isGeneratingPupil = useSelector((state) => state.profs.isGeneratingSinglePupil);


    useEffect(() => {
        if (!generateSinglePupilSuccess) return;
        message.success(generateSinglePupilSuccess?.message);
        dispatch(setGenerateSinglePupil(null));

        setFormData({
            name: "",
            email: "",
            password: "",
            classId
        });
        // Sneaky hack, because we have to wait for formData to be updated before we reset the form.
        setTimeout(() => { formRef?.current.resetFields() }, 300);
        dispatch(fetchClassroom(cookies, { id: classId }));

        setIsAddPupilOpen(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generateSinglePupilSuccess]);

    const onClose = () => {
        setIsAddPupilOpen(false);
    };

    const GeneratePupil = () => {
        let data = {
            name: formData.name,
            email: formData.email,
            password: formData.password,
            classId: formData.classId
        }
        if (pupilExists) {
            data.name = "NomPrenom";
            data.password = "Mot2Passe";
        }
        dispatch(generateSinglePupil(cookies, data));
        // dispatch(updateProf(cookies, formData));
    }

    return (
        <Drawer
            title="Ajouter un élève"
            width={540}
            open={open}
            onClose={onClose}
            extra={
                <Space>
                    <Button onClick={onClose}>Annuler</Button>
                    <Button onClick={GeneratePupil} type="primary">
                        {isGeneratingPupil ? <Spin /> : "Sauvegarder"}
                    </Button>
                </Space>
            }
        >
            <Form
                style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}
                name="notExistsForm"
                layout="vertical"
                initialValues={formData}
                ref={formRef}
            >
                <div style={{ display: "flex", width: "60%", flexDirection: "column" }}>
                    <Form.Item
                        label="L'élève a-t-il un compte ?"
                        name="pupilexists"
                        rules={[
                            { required: false, message: 'Veuillez insérer un nom.' }
                        ]}
                    >
                        <Radio.Group defaultValue={1} onChange={(e) => {setPupilExists(e.target.value === 1 ); setRadioOptions(e.target.value)}} value={radioOptions}>
                            <Radio value={1}>Oui</Radio>
                            <Radio value={0}>Non</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        label="Nom de l’élève"
                        name="name"
                        rules={[
                            { required: false, message: 'Veuillez insérer un nom.' }
                        ]}
                    >
                        <Input
                            defaultValue=''
                            disabled={pupilExists}
                            placeholder="Prénom Nom"
                            value={formData.name}
                            onChange={(e) => { setFormData({ ...formData, name: e.target.value }) }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Adresse mail"
                        name="email"
                        rules={[
                            { required: false, message: 'Veuillez insérer un email.' }
                        ]}
                    >
                        <Input
                            placeholder="John@Doe.com"
                            value={formData.email}
                            onChange={(e) => { setFormData({ ...formData, email: e.target.value }) }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Mot de passe"
                        name="password"
                        rules={[
                            { required: false, message: 'Veuillez insérer un mot de passe.' }
                        ]}
                    >
                        <Input.Password
                            disabled={pupilExists}
                            value={formData.password}
                            onChange={(e) => { setFormData({ ...formData, password: e.target.value }) }}
                        />
                    </Form.Item>
                    <div style={{ justifyContent: "start" }}>
                        <p style={{ color: "#00000073" }}>Le Mot de Passe doit comporter au moins :</p>
                        <ul style={{ paddingLeft: "16px", listStyle: "none" }}>
                            <li style={{ color: "#00000073" }}>De 8 à 12 caractères</li>
                            <li style={{ color: "#00000073" }}>Au moins 1 minuscule</li>
                            <li style={{ color: "#00000073" }}>Au moins 1 majuscule</li>
                            <li style={{ color: "#00000073" }}>Au moins 1 chiffre</li>
                        </ul>
                    </div>
                </div>
            </Form>
        </Drawer>
    )
}